var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReuploadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_866_4312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_866_4312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 16.6663V14.9997H5.62516L5.29183 14.708C4.61127 14.0275 4.11475 13.2879 3.80225 12.4893C3.48975 11.6906 3.3335 10.8747 3.3335 10.0413C3.3335 8.49967 3.7953 7.12815 4.71891 5.92676C5.64252 4.72537 6.84738 3.93023 8.3335 3.54134V5.29134C7.3335 5.65245 6.52794 6.26704 5.91683 7.13509C5.30572 8.00315 5.00016 8.9719 5.00016 10.0413C5.00016 10.6663 5.11822 11.274 5.35433 11.8643C5.59044 12.4545 5.9585 12.9997 6.4585 13.4997L6.66683 13.708V11.6663H8.3335V16.6663H3.3335ZM11.6668 16.458V14.708C12.6668 14.3469 13.4724 13.7323 14.0835 12.8643C14.6946 11.9962 15.0002 11.0275 15.0002 9.95801C15.0002 9.33301 14.8821 8.72537 14.646 8.13509C14.4099 7.54481 14.0418 6.99967 13.5418 6.49967L13.3335 6.29134V8.33301H11.6668V3.33301H16.6668V4.99967H14.3752L14.7085 5.29134C15.3891 5.9719 15.8856 6.71148 16.1981 7.51009C16.5106 8.3087 16.6668 9.12467 16.6668 9.95801C16.6668 11.4997 16.205 12.8712 15.2814 14.0726C14.3578 15.274 13.1529 16.0691 11.6668 16.458Z",
    fill: "#068EFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuploadBlue);
export default __webpack_public_path__ + "static/media/reupload-blue.d4646ec73df8dfc239d424dc0b5bc1ed.svg";
export { ForwardRef as ReactComponent };